import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule } from '@app/layout/layout.module';
import { SharedModule } from '@app/shared/shared.module';
import { SkillStandardsSegmentStatusIndicatorIntermediaryComponent } from './components/skill-standards-segment-status-indicator/skill-standards-segment-status-indicator-intermediary.component';
import { SkillStandardsSegmentStatusIndicatorComponent } from './components/skill-standards-segment-status-indicator/skill-standards-segment-status-indicator.component';

@NgModule({
  declarations: [
    SkillStandardsSegmentStatusIndicatorComponent,
    SkillStandardsSegmentStatusIndicatorIntermediaryComponent,
  ],
  imports: [CommonModule, LayoutModule, SharedModule],
  exports: [
    SkillStandardsSegmentStatusIndicatorComponent,
    SkillStandardsSegmentStatusIndicatorIntermediaryComponent,
  ],
})
export class SkillStandardsSharedModule {}
